import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { StateType } from 'reducer';
import NoPainIcon from 'assets/svg/NoPainIcon';
import MildIcon from 'assets/svg/MildIcon';
import ModerateIcon from 'assets/svg/ModerateIcon';
import SevereIcon from 'assets/svg/SevereIcon';
import HurtsWorstIcon from 'assets/svg/HurtsWorstIcon';
import { usePersistExistingPatientReducer } from 'reducer/existingUser';
import { ConditionalOptionsExistingType } from 'types/existingPatients';
import styles from 'components/existingPatient/page.module.scss';
import MetaTag from 'components/meta';
import Button from 'components/common/button';

type Props = {
  options: ConditionalOptionsExistingType[];
  nextPage: number;
  currentPage?: number;
  actionPage: string;
  multiple?: boolean;
  isFilter?: boolean;
  nextOrSubmitButton: (nextPage: number, submit?: boolean) => void;
};

function PainRateExistingPatient({
  options,
  nextPage,
  nextOrSubmitButton,
  actionPage,
  isFilter = false,
}: Props) {
  const [title, setTitle] = useState('');
  const [error, setError] = useState<boolean>(false);

  const [painRate, setPainRate] = useState<string>('');

  const [state, dispatch] = usePersistExistingPatientReducer();

  useEffect(() => {
    if (isFilter) {
      const getQuestion = options.find(
        (obj: ConditionalOptionsExistingType) => obj.page === actionPage,
      );
      setTitle(getQuestion?.title ?? '');
    }
  }, []);

  useEffect(() => {
    if (state) {
      const data = state.find((object: StateType) => object.name === actionPage);
      if (data) {
        if (data.value) setPainRate(data.value);
      }
    }
  }, []);

  const clickNextOrSubmit = async (nextPage: number) => {
    if (painRate === '') {
      setError(true);
      return;
    }
    const dispatchPayload = {
      type: actionPage,
      name: title,
      value: painRate,
    };

    await dispatch(dispatchPayload);
    nextOrSubmitButton(nextPage);
  };

  return (
    <>
      <MetaTag title={title} />
      <h2 className={`marginTopZero ${styles.titleText}`}>{title}</h2>
      {error && (
      <p className="error-message">
        Please select a value of pain rate.
      </p>
      )}
      <div>
        <p>Please rate your pain on a scale from 1 - 10</p>
        <div className={styles.painRate}>
          <Box
            className={painRate === '0' ? styles.itemActive : styles.item}
            onClick={() => setPainRate('0')}
          >
            <NoPainIcon />
            <p>No Pain</p>
            <p className={styles.painRateValue}>0</p>
          </Box>
          <Box
            className={painRate === '1-3' ? styles.itemActive : styles.item}
            onClick={() => setPainRate('1-3')}
          >
            <MildIcon />
            <p>Mild</p>
            <p className={styles.painRateValue}>1-3</p>
          </Box>
          <Box
            className={painRate === '4-6' ? styles.itemActive : styles.item}
            onClick={() => setPainRate('4-6')}
          >
            <ModerateIcon />
            <p>Moderate</p>
            <p className={styles.painRateValue}>4-6</p>
          </Box>
          <Box
            className={painRate === '7-9' ? styles.itemActive : styles.item}
            onClick={() => setPainRate('7-9')}
          >
            <SevereIcon />
            <p>Severe</p>
            <p className={styles.painRateValue}>7-9</p>
          </Box>
          <Box
            className={painRate === '10' ? styles.itemActive : styles.item}
            onClick={() => setPainRate('10')}
          >
            <HurtsWorstIcon />
            <p>Hurts Worst</p>
            <p className={styles.painRateValue}>10</p>
          </Box>
        </div>
      </div>
      <div className="next-button-fixed">
        <Button onClick={() => clickNextOrSubmit(nextPage)}>
          Next
        </Button>
      </div>
    </>
  );
}

export default PainRateExistingPatient;
